import { Component, OnInit, ViewChild } from '@angular/core';
import { Categorieslist, CategoriesService } from 'src/app/shared/services/categories.service';

import { ProductItem, ProductitemService } from 'src/app/shared/services/productitem.service';
import { Customer, CustomerService } from 'src/app/shared/services/customer.service';
import { Category, Item, ProductResponse, ProductsService, ProductType, Type } from 'src/app/shared/services/products.service';
import { Order, OrderRequest, OrderService } from 'src/app/shared/services/order.service';
import { Header, MessageService, SelectItemGroup } from 'primeng/api';
import autoTable from 'jspdf-autotable';
import jsPDF from 'jspdf';
import { Table } from 'primeng/table';
import { saveAs } from 'file-saver';
import { OpportunityorderService } from 'src/app/shared/services/opportunityorder.service';
import { Stock, StockItemDTO } from 'src/app/domain/stock';
import { StockService } from 'src/app/stock.service';
import { SalesService, Users } from 'src/app/shared/services/sales.service';
import { ProductModuleParents, ProductTrackService } from 'src/app/shared/services/product-module.service';
import { AccessLevelEnum, ApplianceRole, AuthenticationService, CadenceRole } from 'src/app/services/authentication/authentication.service';
import * as moment from 'moment';
import { MasterOrder, MasterOrderRequest, MasterOrderService } from 'src/app/shared/services/master-order.service';
import { StockItemHistory, StockItemHistoryService } from 'src/app/shared/services/stock-item-history.service';
import { DeliveryTicketResponseDTO } from 'src/app/domain/DeliveryTicketResponseDTO';
import { DeliveryTicketRequestDTO } from 'src/app/domain/DeliveryTicketRequestDTO';
import { SalesRep, SalesRepService } from 'src/app/shared/services/sales-rep.service';
import { ItemSummaryDTO } from 'src/app/domain/ItemSummaryDTO';

import * as $ from 'jquery';
import { SpinnerServiceService } from 'src/app/shared/services/spinner-service.service';
import { formatDate } from '@angular/common';


@Component({
  selector: 'app-product',
  templateUrl: './order.component.html',
  styleUrl: './order.component.scss'

})
export class OrderComponent implements OnInit {
  @ViewChild('dt1') table: Table;

  tableData: MasterOrder[] = [];
  loading: boolean = false;
  visible: boolean = false;
  hasCoverage: Boolean = false;
  dialogTitle: string = 'Master Order';
  dialogTitleProduct: string = 'Add Order';
  buttonTitle: string = 'Add Order Line';
  today: Date = new Date();


  //dialog data
  categoryOptions: Categorieslist[] = [];
  itemOptions: ProductItem[] = [];
  typeOptions: ProductType[] = [];
  customerOptions: Customer[] = [];
  opportunityOptions: any[] = [];
  stockOptions: Stock[] = [];
  UserOptions:Users [] = [];
  moduleOptions: ProductModuleParents[] = [];
  moduleOptionsCopy: ProductModuleParents[] = [];
  subjectTitle: String;

  // select dropdown
  selectedCategory: any;
  selectedType: any;
  selectedItem: any;
  selectedOpportunity: any;
  selectedProductId: any;
  selectedstockId: any;

  kind = 'all';

  selectedModule: any;

  // Other form data
  count: number;
  price: number;
  // stockNo: number;
  provisionValue: number;
  startDate: Date;
  endDate: Date;
  salesOrderItemNumber: String;

  maxAvilable: number = 0;

  //master order
  selectedCustomerMasterOrder: any;
  selectedOrderCreatorIdMasterOrder: any;
  orderDateMasterOrder: Date;
  expectedDeliveryDateMasterOrder: Date;
  orderNumberMasterOrder: String;
  salesOrderNumberMasterOrder: String;
  selectedMasterOrderId: any;

  // for load customer

  visibleCustomerOptions: any[] = [];
  totalRecords: number = 0;

  // to create or update
  orderRequest: OrderRequest = {
    id: 0,
    productId: 0,
    opportunityId: 0,
    stockId: 0,
    count: 0,
    startDate: undefined,
    endDate: undefined,
    hasCoverage: false,
    provisionValue: 0,
    price: 0,
    moduleId: 0 ,
    salesOrderItem:'' ,

    batchNumber : '',
    purchaseDate : undefined,
    isRabet : false ,
    poNumber : undefined,
    costPrice : undefined ,
    sellingPrice : undefined ,
    status : undefined ,
    customerStock : false ,
  };

  // dialog for edite data
  categoriesByKind: any[] = [];
  licenseCategories: Category[] = [];
  serviceCategories: Category[] = [];
  productsResponse: ProductResponse;
  groupedCategories: SelectItemGroup[] = [];
  typesByCategory: Type[] = [];
  itemsByType: Item[] = [];

  // renew Dialog
  visibleRenewDialog = false;
  startDateRenew: Date;
  endDateRenew: Date;
  orderNumberRenew: number;
  countRenew: number = 0;
  priceRenew: number;
  selectedOpportunityRenew: any;
  selectedstockIdRenew: any;
  selectedModuleRenew: any;
  provisionValueRenew: number = 0;
  salesOrderItemNumberRenew: String;
  CustomerIdRenew: any;
  createdByRenew: any;
  orderDateRenew: Date ;
  salesOrderRenew: String;
  maxRenewOldDate: Date ;




  // order item
  visibleitemsDialog = false;
  orderItems: StockItemDTO[] = [];
  originalStockItems: StockItemDTO[] = [];
  selectedProducts: StockItemDTO[] = [];

  // roles
  applianceRole: ApplianceRole;
  cadenceRole: CadenceRole;
  public accessLevelEnum = AccessLevelEnum;


  // Product Dialog
  visibleProductItemsDialog = false;
  productItemsDisplay: Order[] = [];
  productItems: OrderRequest[] = [];
  fakeId: number = 0;
  selectedProductItem: any = null;


  //Items History
  visibleitemsHistoryDialog = false;
  ItemsHistory: StockItemHistory[] = [];

  //delivery tickets
  deliveryTickets: DeliveryTicketResponseDTO[] = [];
  showTicketsDialog = false;

  visibleNewDeliveryDialog = false;
  newDeliveryTicket: DeliveryTicketRequestDTO = {
    title: '',
    createdDate: '',
    deliveryDate: '',
    receiverName: '',
    receiverContact: '',
    deliveredBy: '',
    deliveryText: '',
    masterOrderId: 0,
    movementState: '',
    deliveredQty: 0,
    stockItemIds: []
  };
  editMode = false;
  editableDeliveryTickets: DeliveryTicketResponseDTO[] = [];

  visibleDeliveryTicketDialog: boolean = false;
  deliveryTicket: DeliveryTicketResponseDTO;
  showItemsSummaryDialog: boolean = false;
  itemsSummary: ItemSummaryDTO[] = [];

  // Customer Order
  visibleCustomerProductItemsDialog = false;
  customerProductCount: number = 0;
  customerProductCostPrice : number = 0;
  customerProductSellingPrice : number = 0;
  customerProductprovisionValue : number = 0;
  customerProductBatchNumber : string ;
  customerProductStockStatus :number ;
  customerProductStockPurchesDate : Date;
  customerProductRabet : Boolean = false;
  customerProductPONumber : number ;

  statusOptions = [
    { label: 'Reserved', value: 1 },
    { label: 'On Hands', value: 2 }
  ];

  constructor(private categoriesService: CategoriesService,

    private productsService: ProductsService,
    private itemService: ProductitemService, private customerService: CustomerService,
    private orderService: OrderService, private opportunityService: OpportunityorderService,
    private stockService: StockService,
    private messageService: MessageService,
    private salesService: SalesService,
    private productModuleService: ProductTrackService,
    public authenticationService: AuthenticationService,
    public masterOrderService: MasterOrderService,
    private salesRepservice: SalesRepService,
    private stockItemhistoryService: StockItemHistoryService) { }


  async ngOnInit(): Promise<void> {

    SpinnerServiceService.showSpinner();

    // this.applianceRole = this.authenticationService.getApplanceRole();
    // this.cadenceRole = this.authenticationService.getCadenceRole();

    this.masterOrderService.getAllMasterOrder().toPromise().then(response => {
      this.tableData = response;
      // this.tableData.forEach(item => { item.startDate = new Date(item.startDate); item.converageEnd = new Date(item.converageEnd); item.orderDate = new Date(item.orderDate) });
    });

        SpinnerServiceService.hideSpinner();

    await this.categoriesService.getCategoriesList().toPromise().then(response => {
      this.categoryOptions = response;
      // console.log(response);
    });

    await this.productsService.getProductTypes().toPromise().then(response => {
      this.typeOptions = response;
      // console.log(response);
    });

    await this.itemService.getProductItems().toPromise().then(response => {
      this.itemOptions = response;
      // console.log(this.itemOptions);
    });


    await this.customerService.retrieveAllCustomers().toPromise().then(
      response => {
        this.customerOptions = response;
        this.totalRecords = this.customerOptions.length;
        // console.log(this.customerOptions)
      });


      await this.salesService.retrieveMainData().toPromise().then(
        response => {
          this.UserOptions = response.map(user => ({
            ...user,
            fullName: `${user.firstName} ${user.lastName}`
          }));
        });






    this.productsService.getProductsByKind('all').subscribe((data: ProductResponse) => {
      // console.log("all", JSON.stringify(data, null, 2));
      this.productsResponse = data;
      this.categoriesByKind = this.transformCategories(data);

      // console.log("category", JSON.stringify(this.categoriesByKind, null, 2));
    });

    await this.productModuleService.getProductModukesParent().toPromise().then(
      response => {
        this.moduleOptions = response;


        // console.log("moduleOptions", JSON.stringify(this.UserOptions, null, 2));
      });


    this.loadCustomersLazy({ first: 0, rows: 38 });


  }

  loadCustomersLazy(event: any) {
    const start = event.first;
    const end = start + event.rows;
    this.visibleCustomerOptions = this.customerOptions.slice(start, end);
  }



  showDialog() {

    this.visible = true;
    this.selectedCustomerMasterOrder = null;
    this.selectedOrderCreatorIdMasterOrder = null;
    this.orderDateMasterOrder = null;
    this.expectedDeliveryDateMasterOrder = null;
    this.orderNumberMasterOrder = null;
    this.salesOrderNumberMasterOrder = null;
    this.productItems = [];
    this.productItemsDisplay = [];
    this.selectedMasterOrderId = null;
    this.dialogTitle = 'Master Order';
    this.buttonTitle = 'Add Order Line';

  }




   closeDialog() {

    SpinnerServiceService.showSpinner();


    this.selectedCustomerMasterOrder = null;
    this.selectedOrderCreatorIdMasterOrder = null;
    this.orderDateMasterOrder = null;
    this.expectedDeliveryDateMasterOrder = null;
    this.orderNumberMasterOrder = null;
    this.salesOrderNumberMasterOrder = null;
    this.selectedMasterOrderId = null;
    this.productItems = [];
    this.productItemsDisplay = [];
    this.fakeId = 0;
    this.dialogTitle = 'Master Order';
    this.buttonTitle = 'Add Order Line';
    this.visible = false;

      SpinnerServiceService.hideSpinner();
  }



  showProductItemsDialog() {

    this.visibleProductItemsDialog = true;
    this.selectedCategory = null;
    this.selectedType = null;
    this.selectedItem = null;
    this.selectedOpportunity = null;
    this.selectedProductId = null
    this.count = null;
    this.selectedstockId = null;
    this.startDate = null;
    this.endDate = null;
    this.provisionValue = null;
    this.hasCoverage = false;
    this.price = null;
    this.selectedModule = null;
    this.opportunityOptions = null;
    this.maxAvilable = 0;
    this.selectedProductItem = null;
    this.dialogTitleProduct = "Add Order";
    this.salesOrderItemNumber = null;
    this.salesOrderItemNumber = null;

  }

  closeProductItemsDialog() {

    this.visibleProductItemsDialog = false;
    this.selectedCategory = null;
    this.selectedType = null;
    this.selectedItem = null;
    this.selectedOpportunity = null;
    this.selectedProductId = null ;

    this.count = null;
    this.selectedstockId = null;
    this.startDate = null;
    this.endDate = null;
    this.provisionValue = null;
    this.hasCoverage = false;
    this.price = null;
    this.selectedModule = null;
    this.opportunityOptions = null;
    this.maxAvilable = 0;
    this.selectedProductItem = null;
    this.dialogTitleProduct = "Add Order";
    this.stockOptions = null;
    this.salesOrderItemNumber = null;

  }

  // Customer Product Dialog
  showCustomerProductItemsDialog(){
    this.visibleCustomerProductItemsDialog = true;

    this.selectedCategory = null;
    this.selectedType = null;
    this.selectedItem = null;
    this.selectedOpportunity = null;
    this.selectedProductId = null;

    this.customerProductCount = 0;
    this.customerProductBatchNumber= null;
    this.customerProductCostPrice = 0 ;
    this.customerProductSellingPrice = 0;
    this.customerProductPONumber= null;
    this.customerProductStockStatus = 1;
    this.customerProductRabet = false;
    this.customerProductprovisionValue = null;
    this.customerProductStockPurchesDate = null ;

    this.startDate = null;
    this.endDate = null;
    this.hasCoverage = false;

    this.selectedModule = null;
    this.opportunityOptions = null;
    this.salesOrderItemNumber = null;
  }

  closeCustomerProductItemsDialog(){
    this.visibleCustomerProductItemsDialog = false;

    this.selectedCategory = null;
    this.selectedType = null;
    this.selectedItem = null;
    this.selectedOpportunity = null;
    this.selectedProductId = null;

    this.customerProductCount = 0;
    this.customerProductBatchNumber= null;
    this.customerProductCostPrice = 0 ;
    this.customerProductSellingPrice = 0;
    this.customerProductPONumber= null;
    this.customerProductStockStatus = null;
    this.customerProductRabet = false;
    this.customerProductprovisionValue = null;
    this.customerProductStockPurchesDate = null ;

    this.startDate = null;
    this.endDate = null;
    this.hasCoverage = false;

    this.selectedModule = null;
    this.opportunityOptions = null;
    this.salesOrderItemNumber = null;

  }


  // renewDialog for OrderItems

  openRenewOrdersDialog() {

    const ids = this.selectedProducts.map(item => item.id);

    let itemsIds  = {
      stockItemIds : ids
    }

    this.stockService.getOldDateStockItems(itemsIds).toPromise().then(response => {

      this.maxRenewOldDate = new Date (response);
      this.visibleRenewDialog = true;
    }).catch(error => {
      console.error('Error getting stock items:', error);
    });


  }

  ckeckSelectedItems() : Boolean {
    if(this.selectedProducts.length == 0) {
      return true;
    }

    let allAreLicenses = this.selectedProducts.every(item => !item.isLicense);

    return !allAreLicenses;
  }

  saveRenewOrdersDates() {



    let allAreLicenses = this.selectedProducts.every(item => !item.isLicense);


    if(allAreLicenses) {
    let ids = this.selectedProducts.map(item => item.id);
    let dates = {
       itemIds: ids,
       startDate: this.formatDate( this.startDateRenew ),
       endDate: this.formatDate( this.endDateRenew ),
       orderNumber: this.orderNumberRenew ,
       productId: this.selectedProductId ,
       count: this.countRenew ,
       price: this.priceRenew,
       opportunityId: this.selectedOpportunityRenew,
       stockId: this.selectedstockIdRenew,
       moduleId: this.selectedModuleRenew,
       provisionValue: this.provisionValueRenew,
       salesOrderItem: this.salesOrderItemNumberRenew ,
      createdBy: this.createdByRenew,
      orderDate: this.orderDateRenew,
      salesOrder: this.salesOrderRenew

    };

    SpinnerServiceService.showSpinner();

    this.orderService.renewOrders(dates).toPromise().then(response => {
      this.messageService.add({ severity: 'info', summary: 'Order Renewed', detail: 'The order was renewed successfully!' });
      this.visibleRenewDialog = false;

      return this.masterOrderService.getAllMasterOrder().toPromise();
    }).then(updatedOrders => {
      SpinnerServiceService.hideSpinner();
      this.tableData = updatedOrders;

    }).catch(error => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while renewed the order.' });
      console.error('Error creating order or fetching updated orders:', error);
    });
    } else
    {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'You can not renew licenses.' });
    }

    this.closeRenewOrdersDialog();
    this.closeItemsDialog();
  }


  closeRenewOrdersDialog() {
    this.visibleRenewDialog = false;
    this.startDateRenew = null;
    this.endDateRenew = null;
    this.orderNumberRenew = null;
    this.selectedProductId = null;
    this.countRenew = 0;
    this.priceRenew = null;
    this.selectedOpportunityRenew = null;
    this.selectedstockIdRenew = null;
    this.selectedModuleRenew = null;
    this.provisionValueRenew = 0;
    this.salesOrderItemNumberRenew = null;

    this.createdByRenew = null;
    this.orderDateRenew = null;
    this.salesOrderRenew =null;

    this.stockOptions = null;
    this.opportunityOptions = null;
    this.moduleOptionsCopy = null;
    this.moduleOptions = null;

    this.categoryOptions = [];
    this.itemOptions = [];
    this.typeOptions = [];


    this.selectedCategory = null;
    this.selectedType = null;
    this.selectedItem = null;

    this.selectedProducts = [];

  }

  checkRenewData() : Boolean {

    return  this.selectedstockIdRenew == null || this.startDateRenew == null ||
            this.endDateRenew == null || this.createdByRenew == null ||
            this.orderDateRenew == null || this.salesOrderRenew == null ||
            this.salesOrderItemNumberRenew == null ||
            this.selectedProductId == null ||
            this.countRenew == null || this.priceRenew == null ||
            this.provisionValueRenew == null;

  }






  hasCoverageChange() {
    if (!this.hasCoverage) {
      this.startDate = null;
      this.endDate = null;

    }
  }


  getOpportunities(customerId: number, productId: number): void {

    if (customerId == null || productId == null) {
      this.opportunityOptions = null;
      return;
    }

    this.opportunityService.findOpportunitiesByCustomerAndProduct(customerId, productId)
      .subscribe(data => {
        this.opportunityOptions = data;

        // console.log(data)
      });

    // this.getStock(productId , customerId);

  }



  getStock(productId: number, customerId: number): Promise<void> {
    if (productId == null) {
      return Promise.resolve();
    }

    return new Promise<void>((resolve, reject) => {
      this.stockService.getStockByProductId(productId).subscribe(
        data => {
          this.stockOptions = data.filter(item => item.customerId == customerId || item.customerId == null);


          if (this.fakeId < 0) {
            this.updateCount();
          }

          resolve();
        },
        error => reject(error)
      );
    });
  }

  updateCount() {
    for (let i = 0; i >= this.fakeId; i--) {
      const order = this.productItemsDisplay.find(item => item.id === i);
      if (order) {

        const stockIndex = this.stockOptions.findIndex(item => item.batchNumber === order.batchNumber);
        if (stockIndex !== -1) {
          this.stockOptions[stockIndex].availableQuantity = Math.max(
            0,
            this.stockOptions[stockIndex].availableQuantity - order.count
          );

        }
      }
    }

  }



  populateDropdownGroups() {
    this.categoriesByKind = [
      { label: 'License', items: this.licenseCategories },
      { label: 'Service', items: this.serviceCategories }
    ];
  }

  private transformCategories(data: ProductResponse): SelectItemGroup[] {
    const licenseTypes: { label: string, value: Category }[] = [];
    const serviceTypes: { label: string, value: Category }[] = [];

    // Maps to keep track of categories and their types
    const categoryMap: { [key: string]: Category } = {};

    for (const kind in data) {
      for (const categoryName in data[kind]) {
        const types: Type[] = [];

        for (const typeName in data[kind][categoryName]) {
          // Create or update types for the category
          types.push({
            productType: typeName,
            items: data[kind][categoryName][typeName]
          });
        }

        // Create or update the category map
        if (!categoryMap[categoryName]) {
          categoryMap[categoryName] = {
            category: categoryName,
            types: types
          };
        } else {
          // Merge types if the category already exists
          categoryMap[categoryName].types.push(...types);
        }
      }
    }

    // Separate categories into License and Service
    Object.keys(categoryMap).forEach(categoryName => {
      const category = categoryMap[categoryName];
      if (categoryName.toLowerCase() === 'service') {
        serviceTypes.push({
          label: category.category,
          value: category
        });
      } else {
        licenseTypes.push({
          label: category.category,
          value: category
        });
      }
    });
    this.groupedCategories = [
      {
        label: 'License Categories:',
        items: licenseTypes
      },
      {
        label: 'Service Categories:',
        items: serviceTypes
      }
    ];

    return this.groupedCategories;
  }

  formatDate(date: Date): string {
    let format = formatDate(date, 'yyyy-MM-dd', 'en-US');

    return format;
  }


  onSave() {

      SpinnerServiceService.showSpinner();



    let masterOrderRequest: MasterOrderRequest = {
      id: 0,
      customerId: this.selectedCustomerMasterOrder,
      orderNumber: this.orderNumberMasterOrder,
      orderCreatorId: this.selectedOrderCreatorIdMasterOrder,
      orderDate: this.formatDate(this.orderDateMasterOrder),
      orders: this.productItems,
      expectedDeliveryDate: this.formatDate(this.expectedDeliveryDateMasterOrder),
      salesOrder: this.salesOrderNumberMasterOrder

    }


    if (this.selectedMasterOrderId == null) {


      this.masterOrderService.createMasterOrder(masterOrderRequest).toPromise().then(response => {
        this.messageService.add({ severity: 'info', summary: 'Master Order Created', detail: 'The master order was created successfully!' });
        this.visible = false;

        return this.masterOrderService.getAllMasterOrder().toPromise();
      }).then(updatedOrders => {
        this.tableData = updatedOrders;
        SpinnerServiceService.hideSpinner();
        this.tableData.forEach(item => { item.orderDate = new Date(item.orderDate); });
      }).catch(error => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while creating the master order.' });
        console.error('Error creating order or fetching updated orders:', error);
        SpinnerServiceService.hideSpinner();
      });
    } else {
      masterOrderRequest.id = this.selectedMasterOrderId;

      this.masterOrderService.updateMasterOrder(masterOrderRequest).toPromise().then(response => {
        // console.log(response);
        this.messageService.add({ severity: 'info', summary: ' Master Order Update', detail: 'The master order Updated successfully!' });
        this.visible = false;

        return this.masterOrderService.getAllMasterOrder().toPromise();
      }).then(updatedOrders => {
        this.tableData = updatedOrders;
        SpinnerServiceService.hideSpinner();
      }).catch(error => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while Updating the master order.' });
        console.error('Error creating order or fetching updated orders:', error);
        SpinnerServiceService.hideSpinner();
      });
    }


  }




  saveProductitem() {

    let selectedOpportunity = this.opportunityOptions.find(item => item.id == this.selectedOpportunity);

    let Stock = this.stockOptions.find(item => item.stockId == this.selectedstockId);
    const stockEndDate = Stock.stockCoverageEndDate;

    let monthDifference = 0;
    if (this.endDate && stockEndDate) {
      const startDate = moment(this.endDate);
      const endDate = moment(stockEndDate);
      monthDifference = startDate.diff(endDate, 'months');
      monthDifference = Math.max(0, monthDifference);
    }

    if (this.selectedProductItem == null) {

      let fakeId = --this.fakeId;

      let orderResponse: Order = {
        id: fakeId,
        batchNumber: this.stockOptions.find(item => item.stockId == this.selectedstockId).batchNumber,
        stockId: this.selectedstockId,
        opportunityId: this.selectedOpportunity,
        opportunityName: selectedOpportunity ? selectedOpportunity.opportunityName : '',
        productType: this.selectedType.productType,
        productKind: '',
        partNumber: 0,
        converageEnd: this.endDate,
        startDate: this.startDate,
        delta: monthDifference,
        provisionValue: this.provisionValue,
        hasCoverage: this.hasCoverage,
        productId: this.selectedProductId,
        count: this.count,
        price: this.price,
        moduleId: this.selectedModule ? this.selectedModule : 0,
        productCategory: this.selectedCategory.category,
        productItem: this.selectedItem.item,
        moduleName: this.selectedModule ? this.moduleOptionsCopy.find(item => item.id == this.selectedModule).moduleName : '',
        salesOrderItem: this.salesOrderItemNumber
      };

      let orderRequest: OrderRequest = {
        id: fakeId,
        productId: this.selectedProductId,
        opportunityId: this.selectedOpportunity,
        stockId: Stock.stockId,
        count: this.count,
        startDate: this.formatDate( this.startDate),
        endDate: this.formatDate( this.endDate ),
        hasCoverage: this.hasCoverage,
        provisionValue: this.provisionValue,
        price: this.price,
        moduleId: this.selectedModule ? this.selectedModule : 0 ,
        salesOrderItem: this.salesOrderItemNumber ,

        batchNumber : null,
        purchaseDate : null ,
        isRabet : null ,
        poNumber : null ,
        status : null,
        costPrice : null,
        sellingPrice: null ,
        customerStock : false
      };

      this.productItems.push(orderRequest);

      this.productItemsDisplay.push(orderResponse);


    } else {



      let orderResponseIndex = this.productItemsDisplay.findIndex(item => item.id === this.selectedProductItem);
      let orderRequestIndex = this.productItems.findIndex(item => item.id === this.selectedProductItem);



      let orderResponse: Order = {
        id: this.selectedProductItem,
        batchNumber: this.stockOptions.find(item => item.stockId == this.selectedstockId).batchNumber,
        stockId: this.selectedstockId,
        opportunityId: this.selectedOpportunity,
        opportunityName: selectedOpportunity ? selectedOpportunity.opportunityName : '',
        productType: this.selectedType.productType,
        productKind: '',
        partNumber: 0,
        converageEnd: this.endDate,
        startDate: this.startDate,
        delta: monthDifference,
        provisionValue: this.provisionValue,
        hasCoverage: this.hasCoverage,
        productId: this.selectedProductId,
        count: this.count,
        price: this.price,
        moduleId: this.selectedModule ? this.selectedModule : 0,
        productCategory: this.selectedCategory.category,
        productItem: this.selectedItem.item,
        moduleName: this.selectedModule ? this.moduleOptionsCopy.find(item => item.id == this.selectedModule).moduleName : '',
        salesOrderItem: this.salesOrderItemNumber
      };

      let orderRequest: OrderRequest = {
        id: this.selectedProductItem,
        productId: this.selectedProductId,
        opportunityId: this.selectedOpportunity,
        stockId: this.selectedstockId,
        count: this.count,
        startDate: this.formatDate(this.startDate) ,
        endDate: this.formatDate( this.endDate),
        hasCoverage: this.hasCoverage,
        provisionValue: this.provisionValue,
        price: this.price,
        moduleId: this.selectedModule ? this.selectedModule : 0 ,
        salesOrderItem: this.salesOrderItemNumber,

        batchNumber : null,
        purchaseDate : null ,
        isRabet : null ,
        poNumber : null ,
        status : null,
        costPrice : null ,
        sellingPrice : null,
        customerStock : false
      };

      this.productItems[orderRequestIndex] = orderRequest;
      this.productItemsDisplay[orderResponseIndex] = orderResponse;

    }

    this.closeProductItemsDialog();
  }

  saveCustomerProductitem(){

    let selectedOpportunity = this.opportunityOptions.find(item => item.id == this.selectedOpportunity);

    let fakeId = --this.fakeId;

    let orderResponse: Order = {
      id: fakeId,
      batchNumber: this.customerProductBatchNumber,
      stockId: null ,
      opportunityId: this.selectedOpportunity,
      opportunityName: selectedOpportunity ? selectedOpportunity.opportunityName : '',
      productType: this.selectedType.productType,
      productKind: '',
      partNumber: 0,
      converageEnd: this.endDate,
      startDate: this.startDate,
      delta: 0,
      provisionValue: this.customerProductprovisionValue,
      hasCoverage: this.hasCoverage,
      productId: this.selectedProductId,
      count: this.customerProductCount,
      price: this.customerProductSellingPrice,
      moduleId: this.selectedModule ? this.selectedModule : 0,
      productCategory: this.selectedCategory.category,
      productItem: this.selectedItem.item,
      moduleName: this.selectedModule ? this.moduleOptionsCopy.find(item => item.id == this.selectedModule).moduleName : '',
      salesOrderItem: this.salesOrderItemNumber
    };

    let orderRequest: OrderRequest = {
      id: fakeId,
      stockId : null,
      productId: this.selectedProductId,
      opportunityId: this.selectedOpportunity,
      count: this.customerProductCount,
      startDate: this.formatDate( this.startDate),
      endDate: this.formatDate( this.endDate ),
      hasCoverage: this.hasCoverage,
      provisionValue: this.customerProductprovisionValue,
      price: null,
      moduleId: this.selectedModule ? this.selectedModule : 0 ,
      salesOrderItem: this.salesOrderItemNumber ,

      batchNumber : this.customerProductBatchNumber,
      purchaseDate : this.formatDate(this.customerProductStockPurchesDate) ,
      isRabet : this.customerProductRabet ,
      poNumber : this.customerProductPONumber  ,
      costPrice : this.customerProductCostPrice,
      sellingPrice: this.customerProductSellingPrice,
      status : this.customerProductStockStatus,
      customerStock : true
    };

    this.productItems.push(orderRequest);

    this.productItemsDisplay.push(orderResponse);

    console.log( "request" , orderRequest);
    console.log("table" ,orderResponse )

    this.closeCustomerProductItemsDialog();

  }



  customerProductValid() {
    const condition = this.customerProductBatchNumber &&
                      this.customerProductStockStatus &&
                      this.customerProductCount &&
                      this.customerProductCostPrice &&
                      this.customerProductSellingPrice;

    if (this.hasCoverage) {
        return condition && this.startDate && this.endDate;
    }

    return condition;
  }


  productItemValid(){
    const condition = this.selectedstockId;

        if (this.hasCoverage) {
        return condition && this.startDate && this.endDate;
        }

      return condition;
  }

  deleteMasterOrder(id: any) {
    this.masterOrderService.deleteMasterOrder(id).toPromise().then(response => {
      this.messageService.add({ severity: 'info', summary: ' Master Order delete', detail: 'The master order Deleted successfully!' });

      this.tableData = this.tableData.filter(item => item.id !== id);
    }).catch(error => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while Deleting the master order.' });
      console.error('Error deleting order:', error);
    });
  }


  deleteProductItem(id: any) {
    if (id < 0) {
      this.productItemsDisplay = this.productItemsDisplay.filter(item => item.id !== id);
      this.productItems = this.productItems.filter(item => item.id !== id);
    } else {
      this.orderService.deleteOrder(id).toPromise().then(response => {
        this.messageService.add({ severity: 'info', summary: 'Order delete', detail: 'The order Deleted successfully!' });

        this.masterOrderService.getAllMasterOrder().toPromise().then(response => {
          this.tableData = response;
          this.visible = false;

        });
      }).catch(error => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while Deleting the  order.' });
        console.error('Error deleting order:', error);
      });
    }
  }

  editeMasterOrder(id: any) {
    const Data = this.tableData.filter(item => item.id === id);

    this.selectedCustomerMasterOrder = Data[0].customerId;
    this.selectedOrderCreatorIdMasterOrder = Data[0].orderCreatorId;
    this.orderDateMasterOrder = new Date(Data[0].orderDate);
    this.expectedDeliveryDateMasterOrder = new Date(Data[0].expectedDeliveryDate);
    this.orderNumberMasterOrder = Data[0].orderNumber;
    this.selectedMasterOrderId = Data[0].id;

    this.productItemsDisplay = Data[0].orders;
    this.salesOrderNumberMasterOrder = Data[0].salesOrder;


    this.productItems = Data[0].orders.map(order => {
      return {
        id: order.id,
        productId: order.productId,
        opportunityId: order.opportunityId,
        stockId: order.stockId,
        count: order.count,
        startDate: order.startDate,
        endDate: order.converageEnd,
        hasCoverage: order.hasCoverage,
        provisionValue: order.provisionValue,
        price: order.price,
        moduleId: order.moduleId,
        salesOrderItem: order.salesOrderItem,

        batchNumber : null ,
        purchaseDate : null,
        isRabet : null ,
        poNumber : null ,
        costPrice : null,
        sellingPrice : null,
        status : null ,
        customerStock : false

      };
    });

    this.dialogTitle = "Edit Master Order";
    this.buttonTitle = 'Edit Order Line';
    this.visible = true;

  }




  editeProducrItem(id: any) {


    const Data = this.productItemsDisplay.filter(item => item.id === id);

    // Find the category group that matches the product category
    const categoryGroup = this.categoriesByKind.find(group =>
      group.items.some(item => item.label === Data[0].productCategory)
    );

    if (categoryGroup) {
      // Find and set the selected category from the group items
      this.selectedCategory = categoryGroup.items.find(
        item => item.label === Data[0].productCategory
      )?.value; // Access the value property of the matched item

      if (this.selectedCategory.category === "Service") {
        Data[0].productType = 'service';
      }


      if (this.selectedCategory) {
        // Set types for the matched category
        this.typesByCategory = this.selectedCategory.types;

        // Match and set the selected type by text
        this.selectedType = this.typesByCategory.find(
          type => type.productType === Data[0].productType
        );




        if (this.selectedType) {
          // Set items for the matched type
          this.itemsByType = this.selectedType.items;

          // Match and set the selected item by text
          this.selectedItem = this.itemsByType.find(
            item => item.item === Data[0].productItem
          );


        }
      }
    }




    this.selectedProductId = Data[0].productId;


    this.getOpportunities(this.selectedCustomerMasterOrder, this.selectedProductId);
    this.getModuleParentName(this.selectedProductId);
    this.getStock(this.selectedProductId, this.selectedCustomerMasterOrder).then(() => {
      const matchedStock = this.stockOptions.find(
        stock => stock.batchNumber === Data[0].batchNumber
      );

      if (matchedStock) {
        this.selectedstockId = matchedStock.stockId;
        this.count = Data[0].count;
        this.maxAvilable = matchedStock.availableQuantity + this.count;
        this.subjectTitle = "The Available Total Count is";
        this.onCountChange();

      } else {
        this.selectedstockId = null;
      }

      this.dialogTitleProduct = "Edit Order";
      this.visibleProductItemsDialog = true;
    });;

    this.hasCoverage = Data[0].hasCoverage;

    if (this.hasCoverage) {
      this.startDate = new Date(Data[0].startDate);
      this.endDate = new Date(Data[0].converageEnd);
    }

    this.selectedOpportunity = Data[0].opportunityId;
    this.price = Data[0].price;
    this.selectedModule = Data[0].moduleId;
    this.salesOrderItemNumber = Data[0].salesOrderItem;
    this.selectedProductItem = id;

  }



  getModuleParentName(id: any) {
    this.moduleOptionsCopy = this.moduleOptions.filter(item => item.productId == id);
    this.selectedModule = null;
  }

  handleSelectionChanged(selection: any) {

    this.selectedCategory = selection.category;
    this.selectedType = selection.type;
    this.selectedItem = selection.item;
    this.selectedProductId = selection.selectedProductId;

    // Log the values or perform further actions
    // console.log('Selected category:', this.selectedCategory);
    // console.log('Selected type:', this.selectedType);
    // console.log('Selected item:', this.selectedItem);
    // console.log('Selected product ID:', this.selectedProductId);

    this.getOpportunities(this.selectedCustomerMasterOrder, this.selectedProductId);

    this.getStock(this.selectedProductId, this.selectedCustomerMasterOrder);
    this.getModuleParentName(this.selectedProductId);

  }

  customerChange(event: any) {
    this.getOpportunities(this.selectedCustomerMasterOrder, this.selectedProductId);
    this.selectedOpportunity = null;
    if (this.selectedOpportunity != null) {
      this.opportunityChange()
    }
    this.getStock(this.selectedProductId, this.selectedCustomerMasterOrder);

  }

  opportunityChange(): void {
    this.getStock(this.selectedProductId, this.selectedCustomerMasterOrder);

    this.stockOptions = this.stockOptions.filter(item => item.customerId == this.selectedCustomerMasterOrder || item.customerId == null);

    const filteredStock = this.stockOptions.find(item => item.opportunity.id == this.selectedOpportunity);
    this.selectedstockId = filteredStock ? filteredStock.stockId : null;
    this.stockChange();
  }


  stockChange() {
    const filteredStock = this.stockOptions.find(item => item.stockId === this.selectedstockId);
    this.maxAvilable = filteredStock.availableQuantity;
    this.subjectTitle = " The Available Count is"
    this.onCountChange()
  }

  onCountChange() {
    const filteredStock = this.stockOptions.find(item => item.stockId === this.selectedstockId);
    this.provisionValue = (filteredStock.price / filteredStock.quantity) * this.count;
  }

  onCustomerPriceOrCountChange(){
    if(this.customerProductCostPrice ){
      this.customerProductprovisionValue = this.customerProductCostPrice ;
    }
  }

  checkMaxValue(value: number) {
    if (value > this.maxAvilable) {
      this.count = this.maxAvilable;
    }
  }

  getItemStyleClass(item: any): string {
    return item.status === 1 ? 'highlight-item' : '';
  }

  // items dialog

  // Order Items Dialog
  openItemsDialog(orderId: number) {
    this.stockService.getMasterOrderItems(orderId).subscribe((data: StockItemDTO[]) => {
      this.orderItems = data;
      this.selectedMasterOrderId = orderId;
      this.selectedCustomerMasterOrder = data[0].customerId;
      this.originalStockItems = JSON.parse(JSON.stringify(data));
      this.visibleitemsDialog = true;

    });
  }

  closeItemsDialog() {
    this.visibleitemsDialog = false;
    this.orderItems = [];
    this.selectedMasterOrderId = null;
    this.originalStockItems = [];
    this.selectedProducts = [];

  }

  saveOrderItems() {
    const changedItems = this.orderItems.filter((item, index) => {
      return JSON.stringify(item) !== JSON.stringify(this.originalStockItems[index]);
    });

    if (changedItems.length > 0) {
      this.stockService.updateStockItems(changedItems).subscribe(
        response => {
          this.messageService.add({ severity: 'info', summary: 'Order items', detail: 'The order items updateing successfully!' });

          this.closeItemsDialog();
        },
        error => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while updating order items.' });
          console.error('Error updating Order items:', error);
        }
      );
    } else {
      this.closeItemsDialog();
    }

  }


  // Items History Dialog
  showItemsHistory(id: any) {
    this.stockItemhistoryService.getStockItemHistory(id).subscribe((data: StockItemHistory[]) => {
      this.ItemsHistory = data;

    });
    this.visibleitemsHistoryDialog = true;
  }


  // product items
  handleSelectionChangedProduct(selection: any) {

    this.selectedCategory = selection.category;
    this.selectedType = selection.type;
    this.selectedItem = selection.item;
    this.selectedProductId = selection.selectedProductId;

    // Log the values or perform further actions
    // console.log('Selected category:', this.selectedCategory);
    // console.log('Selected type:', this.selectedType);
    // console.log('Selected item:', this.selectedItem);
    // console.log('Selected product ID:', this.selectedProductId);


    this.getOpportunities(this.selectedCustomerMasterOrder, this.selectedProductId);

    this.getStock(this.selectedProductId, this.selectedCustomerMasterOrder);
    this.getModuleParentName(this.selectedProductId);

  }



  opportunityChangeForItemLincese(): void {
    this.getStock(this.selectedProductId, this.selectedCustomerMasterOrder);

    this.stockOptions = this.stockOptions.filter(item => item.customerId == this.selectedCustomerMasterOrder || item.customerId == null);

    const filteredStock = this.stockOptions.find(item => item.opportunity.id == this.selectedOpportunityRenew);
    this.selectedstockIdRenew = filteredStock ? filteredStock.stockId : null;
    this.stockChangeForItemLincese();
  }


  stockChangeForItemLincese() {
    const filteredStock = this.stockOptions.find(item => item.stockId === this.selectedstockIdRenew);
    this.maxAvilable = filteredStock.availableQuantity;

    this.subjectTitle = " The Available Count is"
    this.onCountChangeForItemLincese()
  }

  onCountChangeForItemLincese() {
    const filteredStock = this.stockOptions.find(item => item.stockId === this.selectedstockIdRenew);
    this.provisionValueRenew = (filteredStock.price / filteredStock.quantity) * this.countRenew;
  }


  // checkMaxValueForItemLincese(value: number) {
  //   if (value > this.maxAvilable) {
  //     this.countRenew = this.maxAvilable;
  //   }
  // }



  // xsl export

  exportExcel() {
    import("xlsx").then(xlsx => {
      let datat = this.table.filteredValue ? this.table.filteredValue : this.table.value;
      let index = 0;

      const data = datat.flatMap((masterOrder: MasterOrder) =>
        masterOrder.orders.map((order: Order) => ({
          index: ++index,
          orderNumber: masterOrder.orderNumber,
          customerName: masterOrder.customerName ? masterOrder.customerName.toString() : 'N/A',
          batchNumber: order.batchNumber,
          salesOrder : masterOrder.salesOrder ? masterOrder.salesOrder.toString() : 'N/A',
          opportunityName: order.opportunityName ? order.opportunityName.toString() : 'N/A',
          productCategory: order.productCategory ? order.productCategory.toString() : 'N/A',
          productType: order.productType ? order.productType.toString() : 'N/A',
          productItem: order.productItem ? order.productItem.toString() : 'N/A',
          partNumber: order.partNumber,
          salesOrderItem: order.salesOrderItem,
          startDate: order.startDate ? new Date(order.startDate).toISOString().split('T')[0] : 'N/A',
          coverageEnd: order.converageEnd ? new Date(order.converageEnd).toISOString().split('T')[0] : 'N/A',
          delta: order.delta,
          provisionValue: order.provisionValue,
          price: order.price,
          orderDate: masterOrder.orderDate ? new Date(masterOrder.orderDate).toISOString().split('T')[0] : 'N/A',
          moduleName: order.moduleName ? order.moduleName.toString() : 'N/A',
          creatorName: masterOrder.creatorName ? masterOrder.creatorName.toString() : 'N/A'
        }))
      );

      const worksheet = xlsx.utils.json_to_sheet(data);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "OrderTable");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }



  // pdf export
  exportPdf() {
    const doc = new jsPDF('landscape', 'pt', 'a4');


    const columns = [
      { header: '#', dataKey: 'index' },
      { header: 'Order Number', dataKey: 'orderNumber' },
      { header: 'Customer ', dataKey: 'customerName' },
      { header: 'Batch No.', dataKey: 'batchNumber' },
      { header: 'Sales Order', dataKey: 'salesOrder'},
      { header: 'Opportunity Name', dataKey: 'opportunityName' },
      { header: 'Category', dataKey: 'productCategory' },
      { header: 'Type', dataKey: 'productType' },
      { header: 'Item', dataKey: 'productItem' },
      { header: 'Part No.', dataKey: 'partNumber' },
      { header: 'Sales Order Item', dataKey: 'salesOrderItem' },
      { header: 'Coverage Start', dataKey: 'startDate' },
      { header: 'Coverage End', dataKey: 'coverageEnd' },
      { header: 'Delta (M)', dataKey: 'delta' },
      { header: 'Provision', dataKey: 'provisionValue' },
      { header: 'Price', dataKey: 'price' },
      { header: 'Order Date', dataKey: 'orderDate' },
      { header: 'Module', dataKey: 'moduleName' },
      { header: 'Created By', dataKey: 'creatorName' },

    ];

    let data = this.table.filteredValue ? this.table.filteredValue : this.table.value;

    let index = 0;

    const rows = data.flatMap((masterOrder: MasterOrder) =>
      masterOrder.orders.map((order: Order) => ({
        index: ++index,
        orderNumber: masterOrder.orderNumber? masterOrder.orderNumber.toString() : 'N/A',
        customerName: masterOrder.customerName ? masterOrder.customerName.toString() : 'N/A',
        batchNumber: order.batchNumber,
        salesOrder: masterOrder.salesOrder ? masterOrder.salesOrder.toString() : 'N/A',
        opportunityName: order.opportunityName ? order.opportunityName.toString() : 'N/A',
        productCategory: order.productCategory ? order.productCategory.toString() : 'N/A',
        productType: order.productType ? order.productType.toString() : 'N/A',
        productItem: order.productItem ? order.productItem.toString() : 'N/A',
        partNumber: order.partNumber,
        salesOrderItem: order.salesOrderItem ? order.salesOrderItem.toString() : 'N/A',
        startDate: order.startDate ? new Date(order.startDate).toISOString().split('T')[0] : 'N/A',
        coverageEnd: order.converageEnd ? new Date(order.converageEnd).toISOString().split('T')[0] : 'N/A',
        delta: order.delta,
        provisionValue: order.provisionValue,
        price: order.price,
        orderDate: masterOrder.orderDate ? new Date(masterOrder.orderDate).toISOString().split('T')[0] : 'N/A',
        moduleName: order.moduleName ? order.moduleName.toString() : 'N/A',
        creatorName: masterOrder.creatorName ? masterOrder.creatorName.toString() : 'N/A'
      }))
    );



    autoTable(doc, {
      columns: columns,
      body: rows,
      theme: 'grid',
      styles: {
        font: 'helvetica',
        fontSize: 6,
        cellPadding: 2,
        overflow: 'linebreak',
        cellWidth: 'wrap' ,
        halign : 'left'
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontSize: 8,
        fontStyle: 'bold',
        halign: 'center'
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240]
      },

      columnStyles: {
        index: { halign: 'center' },
        orderNumber: { cellWidth: 40, halign: 'center' },
        productCategory: { cellPadding: 2, halign: 'center' },
        productType: { cellPadding: 2, minCellWidth:30  , cellWidth: "auto", halign: 'center' },
        productItem: { cellPadding: 2, minCellWidth:30 , cellWidth: "auto" , halign: 'center' },
        customer: { cellWidth: "auto", minCellWidth: 60, cellPadding: 4, halign: 'center' },
        batchNumber: { cellWidth: 30, halign: 'center' },
        salesOrder: { cellWidth: 30, halign: 'center' },
        opportunityName: { cellWidth: "auto", minCellWidth: 60,cellPadding: 4, halign: 'center' },
        partNumber: { cellWidth: 30, halign: 'center' },
        salesOrderItem: { cellWidth: 40, halign: 'center' },
        startDate: { cellWidth: 40, halign: 'center' },
        coverageEnd: { cellWidth: 40, halign: 'center' },
        delta: { cellWidth: 25, halign: 'center' },
        provisionValue: { cellWidth: 30, halign: 'center' },
        price: { cellWidth: 25, halign: 'center' },
        orderDate: { cellWidth: 40, halign: 'center' },
        moduleName: { cellWidth: 30, halign: 'center' },
        createdBy: {  halign: 'center' , cellWidth: "auto" }

      },
      margin: { top: 20 , left : 5 , right: 5 }
    });

    doc.save('Orders.pdf');
  }

  getDeliveryTickets(masterOrderId: number): void {

    this.orderService.getDeliveryTicketsByMasterOrderId(masterOrderId).subscribe(
      (tickets: DeliveryTicketResponseDTO[]) => {
        this.deliveryTickets = tickets;
        this.editableDeliveryTickets = this.deliveryTickets.map(ticket => ({...ticket}));
        this.showTicketsDialog = true;
      },
      (error) => {
        console.error('Error fetching delivery tickets:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while fetching delivery tickets.' });
      }
    );
  }


  toggleEditMode(): void {
    this.editMode = !this.editMode;
    if (!this.editMode) {
      // Reset to original data when exiting edit mode
      this.editableDeliveryTickets = this.deliveryTickets.map(ticket => ({...ticket}));
    }
  }
  openNewDeliveryDialog() {

    this.visibleNewDeliveryDialog = true;
    this.newDeliveryTicket = {
      title: '',
      createdDate: '',
      deliveryDate: '',
      receiverName: '',
      receiverContact: '',
      deliveredBy: '',
      deliveryText: '',
      masterOrderId: this.selectedMasterOrderId,
      movementState: '',
      deliveredQty: 0,
      stockItemIds: this.selectedProducts.map(product => product.id)
    };
  }
  createDeliveryTicket() {
    if (this.newDeliveryTicket.createdDate) {
      this.newDeliveryTicket.createdDate = this.transformDate(this.newDeliveryTicket.createdDate);
      this.newDeliveryTicket.deliveryDate = this.transformDate(this.newDeliveryTicket.deliveryDate);
    }

    this.orderService.createDeliveryTicket(this.newDeliveryTicket).subscribe(
      (response) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Delivery ticket created successfully!' });
        this.visibleNewDeliveryDialog = false;
        this.getDeliveryTickets(this.selectedMasterOrderId);
      },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while creating the delivery ticket.' });
        console.error('Error creating delivery ticket:', error);
      }
    );
  }

  transformDate(dateString: string): string {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  viewDeliveryTicket(stockItemId: number) {
    this.orderService.getDeliveryTicketByStockItemId(stockItemId).subscribe(
        (ticket: DeliveryTicketResponseDTO) => {
            this.deliveryTicket = ticket;
            this.visibleDeliveryTicketDialog = true;
        },
        (error) => {
            console.error('Error fetching delivery ticket', error);
        }
    );
}

updateDeliveryTicket() {
  if (this.deliveryTicket && this.deliveryTicket.id) {
    const requestDTO: DeliveryTicketRequestDTO = {
      title: this.deliveryTicket.title,
      createdDate: this.formatDate(this.deliveryTicket.createdDate),
      deliveryDate: this.formatDate( this.deliveryTicket.deliveryDate),
      receiverName: this.deliveryTicket.receiverName,
      receiverContact: this.deliveryTicket.receiverContact,
      deliveredBy: this.deliveryTicket.deliveredBy,
      deliveryText: this.deliveryTicket.deliveryText,
      masterOrderId: this.selectedMasterOrderId,
      movementState: this.deliveryTicket.movementState,
      deliveredQty: this.deliveryTicket.deliveredQty,
      stockItemIds:this.selectedProducts.map(product => product.id)
    };

    this.orderService.updateDeliveryTicket(this.deliveryTicket.id, requestDTO).subscribe(
      (updatedTicket: DeliveryTicketResponseDTO) => {
        this.deliveryTicket = updatedTicket;
        this.visibleDeliveryTicketDialog = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Delivery ticket updated successfully' });
      },
      (error) => {
        console.error('Error updating delivery ticket', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update delivery ticket' });
      }
    );
  }
}

fetchItemsSummary(deliveryTicketId: number): void {
  this.orderService.getItemSummary(deliveryTicketId).subscribe(
      (items: ItemSummaryDTO[]) => {
          this.itemsSummary = items;
          this.showItemsSummaryDialog = true;
      },
      (error) => {
          console.error('Error fetching serial numbers:', error);
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch serial numbers.' });
      }
  );
}

saveDeliveryTickets(): void {
  // Convert editable tickets to request DTOs
  const updateRequest: DeliveryTicketRequestDTO[] = this.editableDeliveryTickets.map(ticket => ({
    id: ticket.id,
    title: ticket.title,
    createdDate: this.formatDate(ticket.createdDate),
    deliveryDate: this.formatDate(ticket.deliveryDate),
    receiverName: ticket.receiverName,
    receiverContact: ticket.receiverContact,
    deliveredBy: ticket.deliveredBy,
    deliveryText: ticket.deliveryText,
    masterOrderId: this.selectedMasterOrderId,
    movementState: ticket.movementState,
    deliveredQty: ticket.deliveredQty,
  }));

  this.orderService.updateMultibleTickets(updateRequest).subscribe(
    (updatedTickets: DeliveryTicketResponseDTO[]) => {
      this.deliveryTickets = updatedTickets;
      this.editableDeliveryTickets = updatedTickets.map(ticket => ({...ticket}));
      this.editMode = false;
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Delivery tickets updated successfully'
      });
    },
    (error) => {
      console.error('Error updating delivery tickets', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to update delivery tickets'
      });
    }
  );
}


ckeckSelectedStockForTicketing(): boolean {
  if (this.selectedProducts.length === 0) {
    return true;
  }

  const hasTicketedProduct = this.selectedProducts.some(item => item.deliveryTicket != null);

  return hasTicketedProduct;
}


checkItemTicketExist(stockItemId: number): boolean {
  return !this.selectedProducts.some(item => item.id === stockItemId && item.deliveryTicket != null);
}



}


